import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getTerminatedVpOppVolumeOppByMember, getTerminatedVpOppConversionOppPoDetails,
  getTerminatedVpOppConversionOpp, getTerminatedVpOppTopTenMembers,saveProductFeedback,
  getTerminatedVpOppVolumeOppByProductGroup, getTerminatedVpOppTopTenProductGroups,getConversionOppVendorList,
  getTerminatedVpOppVendorNames,getProductDetail,getProductCategorycorporate,
  getTerminatedVPNamesForCorporate,getCorporateConversionMonthsFilter,tabTracking
} from '../../../actions';
import _get from 'lodash/get';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import Filters from '../../../components/Filters';
import accounting from 'accounting-js';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import C3Chart from 'react-c3js';
import swal from 'sweetalert';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import { Checkbox,TextArea} from 'semantic-ui-react'
import { Card, Form, Button,OverlayTrigger, Tooltip} from 'react-bootstrap';
import 'c3/c3.css';
import { matLoader } from '../../../components/Loader';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { PriceFormatter, dynamicDateFilters1, VirtualizedPriceFormatter,monthName1, jsonToParam, paramsToJSON,paramsToJSON1} from '../../../helper';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ReactExport from "react-export-excel";
import 'react-virtualized/styles.css';
import { Column, Table, AutoSizer, InfiniteLoader } from 'react-virtualized';

class TerminatedVPOpportunity extends React.Component {
  state = {
 selectedFilterPeriod: "YTD",
            buttonOptionsPeriod: ["MTH", "YTD", "QTR"],
            showQuarter: false,
            dataval:[],
            items: [],
            selectedYear: new Date().getFullYear(),
            selectedItem: new Date().getMonth(),
    isLoading: true,
    ListData:[],
    params: {
      period: "YTD",
      ytd: "true",
      qtr: "false",
      mth: "false",
      year: 2022,
      month: 12,
      quarter: 1,
      buyingGroupId: 0,
      terminatedVendorId: 441,
      productGroupId:'',
      vendorId: "",
      memberId: "",
      startRowNo: 0,
      index : 0,

    },
    suggestedFavorableVp: '',
    suggestedBhCategory: '',
    suggestedBhCategoryId: '',
    disableBhCategoryDropdown: true,
    selectFavorableVpErrorMessage: '',
    numberOfFavorableVp: '',
    textareaValue:'',
    showPopUpForFavorableVp: false,
    disableNewProductCategoryDropdown:true,
    favorableVendorId:'',
    selectedFavorableVp: '',
    selectedCategory: '',
    selectedProduct: '',
    selectedProductId: '',
    feedbackToggle: '',
    listOfBhCategories: [{
        key: 1,
        text: 'BH Category 1',
        value: 'BH Category 1',
    }, {
        key: 2,
        text: 'BH Category 2',
        value: 'BH Category 2',
    }],
    listOfVendorPartners: [
        {
            key: 1,
            text: 'Supplier Partner 1',
            value: 'Supplier Partner 1',
        },
        {
            key: 2,
            text: 'Supplier Partner 2',
            value: 'Supplier Partner 2',
        },
    ],
    unapprovedSuppliersByCategoryData: [{
        categoryId: 1,
        categoryName: 'Category 1',
        salesOpportunity: '',
        rebateOpportunity: '',
        vendor1: 'vp1',
        vendor2: 'vp2',
        vendor3: 'vp3',
        vendor4: 'vp4',
        feedback: ''
    }],
    isLoading: true,
    disableVendorDropdown:true,
    vendorPartnerOptions: [],
    programNameOptions: [],
    selectedVendorPartner: null,
    selectedProgramName: null,
    displayModal: false,
    showPopUpForProductFedbackDetails:false,
    propsForModal: {

    },
    cardData: [],
    products: [{
        id: 1,
        name: "Product1",
        price: 120
    }, {
        id: 2,
        name: "Product2",
        price: 80
    }],
    showProductsModal: false,

    dataForChart1: {
      legend: {
        position: 'inset',
        show: false,
        inset: {
          anchor: 'top-left',
          x: 20,
          y: -40,
          step: 1
        }
      },
      padding: {
        bottom: 100,
      },
      data: {
        columns: [],
        type: 'bar',
        colors: {
          data1: '#ff0000'
        },
      },
        tooltip: {
          format: {
              title: d => this.props.top10Members.chartData1Member[d+1],
              value: (value, ratio, id) => accounting.formatMoney(value)
          }
      },
      bar: {
        width: {
          ratio: 0.5 // this makes bar width 50% of length between ticks
        },
      }, 
      axis: {
        x: { label: { text : 'Member Ids', position: 'inner-right' },
          type: 'category', // this needed to load string x value,
          tick: {
            rotate: -23,
            multiline: false,
          },
          height: 80
        },
          y: { label: { text : 'Purchase Amount', position: 'outer-middle' } ,
          type: 'categoryId',
          tick: {
            rotate: -20,
            multiline: false,
            format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
            //                format: function (d) { return "$" + d; }
          }
        }
      }
    },
    
    dataForChart2: {
      legend: {
        position: 'inset',
        show: false,
        inset: {
          anchor: 'top-left',
          x: 20,
          y: -40,
          step: 1
        }
      },
      padding: {
        bottom: 100,
      },
      data: {
        columns: [],
        type: 'bar',
        colors: {
          data1: '#ff0000',
        },
      },
      tooltip: {
        format: {
            title: d => this.props.top10ProductGroups.chartData1PG[d+1],
            value: (value, ratio, id) => accounting.formatMoney(value)
        }
    },
      bar: {
        width: {
          ratio: 0.5 // this makes bar width 50% of length between ticks
        },
        // or
        //width: 100 // this makes bar width 100px
      }, axis: {
          x: { label: { text : 'Rank', position: 'inner-right' },
          type: 'category', // this needed to load string x value,
          tick: {
            rotate: -20,
            multiline: false
          },
          height: 80
        },
       
          y: { label: { text : 'Purchase Amount', position: 'outer-middle' } ,
          tick: {
            rotate: -20,
            multiline: false,
            format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
            //                format: function (d) { return "$" + d; }
          }
        }
      }
    },
    styleFirstRow: { paddingBottom: "12px", paddingTop: "0", marginLeft: this.props.isExpanded ? "250px" : "64px", marginTop: "8rem" },
    styleRow: { paddingBottom: "12px", paddingTop: "0", marginLeft: this.props.isExpanded ? "250px" : "64px" }
  }

  stopIndex = 1;

  actuallyLoadMore = (startIndex) => {
    let params = this.state.params;
        params = paramsToJSON1(params);
        params.startRowNo = startIndex;
        params = jsonToParam(params);
      this.stopIndex != startIndex && 
      this.setState({ 
        params: {...params}},()=>{
          this.props.getTerminatedVpOppConversionOppAPI(params).then(data=>{
              let newDataWithOldData = [...this.state.ListData,...data];
              this.setState({
                params: params,
                  ListData:newDataWithOldData,
              })
              this.promiseResolve();
          });
      })

      this.stopIndex = startIndex;
  }

  loadMore = (index) => {
    //
    let params = this.state.params;
    params = paramsToJSON1(params);
      console.log('index in load more',index)
      this.actuallyLoadMore((index.startIndex) +1 )
      return new Promise((resolve, reject) => {
          this.promiseResolve = resolve;
       })
  }
 
  showProductdata = (cell, row) => {
    return (
      <OverlayTrigger overlay={(<Tooltip id="hi">Product Details for {row.productGroupName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
           
        <Link onClick={(e) => {
          e.preventDefault();
            this.showProductInfo(row)
        }}><i class="fa fa-info-circle"></i></Link>
        </OverlayTrigger>
    )
}
showProductInfo = (row) => {
    //
    this.setState({productGroupId: row.productGroupId,productGroupName : row.productGroupName, showProductInfo: true },()=>{
      // let params = this.state.params;
      // params = paramsToJSON(params);
      // 
      
      //     params.productGroupId= this.state.productGroupId,
      //     params.year = this.state.params.year,
         
       
      //     params = jsonToParam(params);
      let selections = this.state.params;
      selections = paramsToJSON1(selections);
      selections.productGroupId = this.state.productGroupId;

      selections = jsonToParam(selections);
      console.log(selections);
      //  
       // console.log(selections);
                      this.props.getProductDetailAPI(selections, (res) =>  {
                        toast(res.data.text);
                    });
                        // this.setState({ showProductListModal: false});
                      });
                    }
    closeProductInfo = () => {
    this.setState({ showProductInfo: false});
}

 handleUserSelectedFilter(option) {
  let obj = {};
         
  if (option === "qtr" || option === "QTR") {
      this.setState({ showQuarter: true });
  } else {
      this.setState({ showQuarter: false });
  }
 
let paramsValues = this.state.params;
let paramsfinal = paramsToJSON1(paramsValues);
let month = paramsfinal.month;
if(month >= 1 && month <= 3){
  paramsfinal.quarter= 1
}
else if(month >= 4 && month <= 6){
  paramsfinal.quarter = 2
}
else if(month >= 7 && month <= 9){
  paramsfinal.quarter = 3
}
else if(month >= 10 && month <= 12){
  paramsfinal.quarter = 4
}

let params = jsonToParam(paramsfinal);
            this.setState({ selectedFilterPeriod: option,params: params}, () => {
            this.setFilter({ period: this.state.selectedFilterPeriod, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });

    }
  componentWillMount() {

    let paramsValues = this.state.params;
    let paramsfinal = dynamicDateFilters1(paramsValues);
    let params = jsonToParam(paramsfinal);
    this.setState({ params })
  }

  componentDidMount() {
   console.log('filters ', this.props.showMonth == "false");
        console.log(this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptionsPeriod: ["YTD", "QTR"], selectedFilterPeriod: "YTD" });
        }
    Promise.all([
      this.props.getCorporateConversionMonthsFilterAPI(this.state.params),
      this.props.tabTrackingAPI("tabId=15"),
      // this.props.getTerminatedVpOppTopTenMembersAPI(this.state.params),
      // this.props.getTerminatedVpOppVolumeOppByMemberAPI(this.state.params),
      // this.props.getTerminatedVpOppTopTenProductGroupsAPI(this.state.params),
      // this.props.getTerminatedVpOppVolumeOppByProductGroupAPI(this.state.params),
      // this.props.getTerminatedVpOppConversionOppPoDetailsAPI(this.state.params),
      // this.props.getTerminatedVpOppVendorNamesAPI(),
      // this.props.getTerminatedVpOppConversionOppAPI(this.state.params),
      // this.props.getProductCategorycorporateAPI(this.state.params),
      // this.props.getTerminatedVPNamesForCorporateAPI(this.state.params),
      // this.props.getMemberVendorNamesAPI(this.state.params)
     
    ]).then(([COData,data]) => {
     this.getOptions();
     this.getOptionsYear();
      this.setState({
          isLoading: false,
          // purchasedOrderRowsArr: data
          ListData: COData,
      })
    // .then(data => {

    //   this.setState({
    //     isLoading: false
    //   })
    }).catch(err => {

      this.setState({
        isLoading: false
      })
    }) 
    let checkStorage = localStorage.setItem('flag','11')
    setTimeout(function () { localStorage.removeItem("flag"); }, 5000);

  }
  handleChangeOfDropdownYear(e) {
    let params = this.state.params;
    params = paramsToJSON1(params);
    let year = ''
    let items =[]
    params.year = e.value
    year = params.year
    let selectedYear=  {label: year , value :year}
    let dataval = Object.keys(this.props.getCorporateConversionMonthsFilter);
    let yearval = dataval.map((val) => {
        return {
            label: val,
            value: val,
        }
    })

    let selectedYear1 = yearval[yearval.length - 1];
    // if (selectedYear1.value != 2023 && e.value == 2023 )
    if (selectedYear1.value != 2024 && e.value == 2024 )
    {
        items = [{ label: monthName1(1),value: 1}];
    }
    else {
    let dataval1 = Object.values(this.props.getCorporateConversionMonthsFilter[year]);
    if(typeof dataval1 == 'undefined')
        {
          items = [{ label: monthName1(1),value: 1}];
      
        }
        else{
          items = dataval1.map(itemval => {
              return {
                  label: monthName1(itemval),
                  value: itemval,
              }
  
          })
      }
    }
    
    let selectedItem = items[items.length - 1];
    params.month = selectedItem.value;
    let month = selectedItem.value;
    if (month >= 1 && month <= 3) {
        params.quarter = 1
    }
    else if (month >= 4 && month <= 6) {
        params.quarter = 2
    }
    else if (month >= 7 && month <= 9) {
        params.quarter = 3
    }
    else if (month >= 10 && month <= 12) {
        params.quarter = 4
    }
    params = jsonToParam(params);
    this.setState({
        params: params,
        selectedYear: selectedYear,
        items: items,
        selectedItem : selectedItem,
})
this.setState(e, () => {
    this.setFilter({ year: this.state.year, selectedYear: selectedYear,selectedItem:selectedItem });
});
   
//     let params = this.state.params;
//     params = paramsToJSON1(params);
//     let year = ''
//     params.year = e.value
//     year = params.year
//     let selectedYear=  {label: year , value :year}

//     params = jsonToParam(params);
//         this.setState({
//             params: params,
//             selectedYear: selectedYear,
//         }, this.getOptions)

// console.log(this.state.selectedYear);


}
getOptionsYear(){
    let dataval = Object.keys(this.props.getCorporateConversionMonthsFilter);
    let yearval = dataval.map((val) =>
        {
            return {
                label: val,
                value: val,
            }
    })
    let selectedYear=  yearval[yearval.length - 1];
    // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
      if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        else if (selectedYear.value != 2023 && selectedYear.value != 2024){
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });
        }
        //add this new code
        else if (selectedYear.value != 2024){
          yearval.push({ label: 2024, value: 2024 });

      }
    // params = jsonToParam(params);
    this.setState({
        selectedYear:selectedYear,
        yearval:yearval,
        // params: params ,
    })
}

    getOptions(){
      
        let params = this.state.params;
        params = paramsToJSON(params);
        let items =[]
   
        let dataval = Object.keys(this.props.getCorporateConversionMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];

        let dataval1 = Object.values(this.props.getCorporateConversionMonthsFilter[selectedYear1.value]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }

        if (selectedYear1.value != 2022)
        {
        yearval.push({ label: 2022, value: 2022 });
        }
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        params.year = selectedYear1.value;
        let month = selectedItem.value;
        if(month >= 1 && month <= 3){
            params.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            params.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            params.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params ,
        })
        this.props.getTerminatedVpOppTopTenMembersAPI(params)
        this.props.getTerminatedVpOppVolumeOppByMemberAPI(params)
        this.props.getTerminatedVpOppTopTenProductGroupsAPI(params)
        this.props.getTerminatedVpOppVolumeOppByProductGroupAPI(params)
        this.props.getTerminatedVpOppConversionOppPoDetailsAPI(params)
        this.props.getTerminatedVpOppVendorNamesAPI()
        this.props.getProductCategorycorporateAPI(params)
        this.props.getTerminatedVPNamesForCorporateAPI(params)
        this.props.getMemberVendorNamesAPI(params)
        this.props.getTerminatedVpOppConversionOppAPI(params)

}
    
    renderButtonGroup() {

        return this.state.buttonOptionsPeriod.map((option, index) => {
            return (
                <button style ={{height:'38px'}} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilterPeriod === option) ? "active" : null}`}>{option}</button>
            )
        })
    }
//   showPopUpForFavorableVp1 = (cell,row) => {
//     if (_isEmpty(cell.cellData)) {
//         return (
//             <div></div>
//         )
//     }
//     return (
//         <div onClick={(e) => this.showModalForFavorableVendor(1, cell, cell.cellData)}>{cell.cellData} <i class="fas fa-comment-alt"></i></div>
//     )
// };
// showPopUpForFavorableVp2 = (cell, row) => {
//     if (_isEmpty(cell.cellData)) {
//         return (
//             <div></div>
//         )
//     }
//     return (
//         <div onClick={(e) => this.showModalForFavorableVendor(2, cell, cell.cellData)}>{cell.cellData} <i class="fas fa-comment-alt"></i></div>
//     )
// };
// showPopUpForFavorableVp3 = (cell, row) => {
//     if (_isEmpty(cell.cellData)) {
//         return (
//             <div></div>
//         )
//     }
//     return (
//         <div onClick={(e) => this.showModalForFavorableVendor(3, cell, cell.cellData)}>{cell.cellData} <i class="fas fa-comment-alt"></i></div>
//     )
// };
// showPopUpForFavorableVp4 = (cell, row) => {
//     if (_isEmpty(cell.cellData)) {
//         return (
//             <div></div>
//         )
//     }
//     return (
//         <div onClick={(e) => this.showModalForFavorableVendor(4, cell, cell.cellData)}>{cell.cellData} <i class="fas fa-comment-alt"></i></div>
//     )
// };
// showPopUpForFavorableVp5= (cell, row) => {
//   if (_isEmpty(cell.cellData)) {
//       return (
//           <div></div>
//       )
//   }
//   return (
//       <div onClick={(e) => this.showModalForFavorableVendor(5, cell, cell.cellData)}>{cell.cellData} <i class="fas fa-comment-alt"></i></div>
//   )
// };
// showModalForFavorableVendor = (num, row, cell,vpSelected) => {
//   if (num === 1 ){
//    let favorableVendorId = row.rowData.favorableVendor1Id;
//    let favorableVendorName = row.rowData.favorableVendor1Name;
//    this.setState({favorableVendorId :row.rowData.favorableVendor1Id})
//   }
//   else if (num === 2 ){
//     let favorableVendorId = row.rowData.favorableVendor2Id
//     let favorableVendorName = row.rowData.favorableVendor2Name
//     this.setState({favorableVendorId :row.rowData.favorableVendor2Id})
//   }
//   else if (num === 3 ){
//     let favorableVendorId = row.rowData.favorableVendor3Id
//     let favorableVendorName = row.rowData.favorableVendor3Name
//     this.setState({favorableVendorId :row.rowData.favorableVendor3Id})
//   }
//   else if (num === 4 ){
//     let favorableVendorId = row.rowData.favorableVendor4Id
//     let favorableVendorName = row.rowData.favorableVendor4Name
//     this.setState({favorableVendorId :row.rowData.favorableVendor4Id})
//   }
//   else if (num === 5 ){
//     let favorableVendorId = row.rowData.favorableVendor5Id
//     let favorableVendorName = row.rowData.favorableVendor5Name
//     this.setState({favorableVendorId :row.rowData.favorableVendor2Id})
//   }
//   //this.setState({favorableVendorId :favorableVendorId})
//     this.setState({ numberOfFavorableVp: num, productId: row.rowData.productGroupId,productDesc:row.rowData.productGroupName,
//       favorableVendorId:this.state.favorableVendorId,
//         favorableVendorName: cell, showPopUpForFavorableVp: true })
// }

// closeFavorableVendorModal = () => {
//     this.setState({ showPopUpForFavorableVp: false,disableVendorDropdown:true,selectFavorableVpErrorMessage:'' });
// }
// handleClickVendor = (e, value) => {
//   let arr = [];
//   let arr1 = [];
//   let valuestr = [value.value];
//   if (valuestr > 0) {
//       let valueee = valuestr.map((option, index) => {
//           let val = _find(value.options, ['value', option])
//           arr.push(val.value)
//           arr1.push(val.text)
//       })


//   }
//   this.setState({ suggestedFavorableVendorId: encodeURIComponent(arr), suggestedFavorableVendorName: encodeURIComponent(arr1),selectFavorableVpErrorMessage:'' })

// }
// sendFeedbackForFavorableVendor() {
// let selections = {
//       productId: this.state.productId,
//       productDesc: this.state.productDesc,
//       favorableVendorId:"",
//       favorableVendorName:this.state.favorableVendorName,
//       feedbackComment:this.state.textareaValue,
//       favorableVendorWrong :this.state.feedbackToggleForFavorableVp,
//       suggestedFavorableVendorId:this.state.suggestedFavorableVendorId,
//       suggestedFavorableVendorName:this.state.suggestedFavorableVendorName,
//   }

//     if (!this.state.suggestedFavorableVendorName) {
//       this.setState({ selectFavorableVpErrorMessage: 'Please select a Supplier' }, () => {
//       });
//   } else {
//     this.setState({ showPopUpForFavorableVp: false, selectFavorableVpErrorMessage: '' }, () => {
//       this.props.saveProductFeedbackAPI(selections, (res) => {
//         swal(res.data.text);

//     });

//     });
// }
// }
renderSizePerPageDropDown = props => {
  return (
    <div className='btn-group'>
      {
        [ 25, 50, 100 ].map((n, idx) => {
          const isActive = (n === props.currSizePerPage) ? 'active' : null;
          return (
            <button key={ idx } type='button' className={ `btn btn-info ${isActive}` } onClick={ () => props.changeSizePerPage(n) }>{ n }</button>
          );
        })
      }
    </div>
  );
}
  renderOpportunityByMember() {
    const { volumeOpportunityByMember } = this.props;
    const options = {
      // sizePerPage: 100,
      // paginationShowsTotal: this.renderPaginationShowsTotal,
      sizePerPageDropDown: this.renderSizePerPageDropDown
             
    }
    return (
      <div className="" >
        <div className="card-deck">
          <div className="card shadow-sm mb-3">

            {/* <div className="card-header">
              Opportunity by Member
                        </div> */}
            <div className="card-body" style={{ maxHeight: " 303" }}>
            <h5 style={{textDecorationLine: 'underline',marginBottom:'-20px'}}>Opportunity by Member</h5>

              <BootstrapTable search options={options} pagination height='298' data={volumeOpportunityByMember} striped hover version="4">
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='memberId'> Id </TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='memberName'>Member Name</TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='purchases'>Purchase</TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='leavingVendorName'>Leaving Supplier</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div>
    )
  }
  renderOpportunityByProductGroup() {
    const { terminatedVpOppVolumeOppByProductGroup } = this.props;
    const options = {
      // paginationShowsTotal: this.renderPaginationShowsTotal,
      
      //     sizePerPage: 100,
      sizePerPageDropDown: this.renderSizePerPageDropDown
          // paginationShowsTotal: true ,
        
  }
    return (
      <div className="">
        <div className="card-deck">
          <div className="card shadow-sm mb-3">

            <div className="card-body" style={{ maxHeight: " 305" }}>
            <h5 style={{textDecorationLine: 'underline',marginBottom:'-20px'}}> Opportunity by Product group</h5>
              <BootstrapTable search options= {options} pagination height='298' data={terminatedVpOppVolumeOppByProductGroup} striped hover version="4">
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal'}} thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='productGroupName'>Product Group</TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='purchases'>Purchases</TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='leavingVendorName'>Leaving Supplier</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="80" dataFormat={this.showProductdata} dataField='productGroupId'>Products</TableHeaderColumn>
              </BootstrapTable>

            </div>
          </div>
        </div>
      </div>
    )
  }
//   getCategoryDefaultData = row => {
//     let params = this.state.params;
//     this.props.getTerminatedVpOppConversionOppAPI(params);
// }
  // renderConversionOpportunity() {
  //   return (
  //     <div className="" style={{marginBottom: '20px'}}>
  //           <h5 style={{textDecorationLine: 'underline'}}>Conversion Opportunity</h5>
  //           <InfiniteLoader
  //                               isRowLoaded={({ index }) => index < this.state.ListData.length }
  //                               loadMoreRows={this.loadMore}
  //                               rowCount={100000}
  //                           >
  //                               {({ onRowsRendered, registerChild }) => (
  //                                   <AutoSizer>
  //                                       {({ width }) => (
  //                                           <Table
  //                                               ref={registerChild}
  //                                               onRowsRendered={onRowsRendered}
  //                                               rowClassName='table-row'
  //                                               headerHeight={50}
  //                                               width={width}
  //                                               height={400}
  //                                               rowHeight={60}
  //                                               rowCount={this.state.ListData.length}
  //                                               rowGetter={({ index }) => this.state.ListData[index]}>
  //                                               <Column style={{ whiteSpace: "normal" }} label="Leaving Supplier" dataKey="leavingVendorName" width={300} />
  //                                               <Column style={{ whiteSpace: "normal" }} label="Member Name" dataKey="memberName" width={300} />
  //                                               <Column style={{ whiteSpace: "normal" }} label="Business Group" dataKey="businessGroupName" width={300} />
  //                                               <Column style={{ whiteSpace: "normal" }} type='hidden' label="Product Id" dataKey="productGroupId" width={400} />
  //                                               <Column style={{ whiteSpace: "normal" }} label="Product Group" dataKey="productGroupName" width={400} />
  //                                               <Column style={{ whiteSpace: "normal" }} cellRenderer={VirtualizedPriceFormatter} label="Purchases" dataKey="purchases" width={300} />
  //                                               <Column style={{ whiteSpace: "normal" }} cellRenderer={this.showPopUpForFavorableVp1} label="Favorable Supplier 1" dataKey="favorableVendor1Name" width={400} />
  //                                               <Column style={{ whiteSpace: "normal" }} cellRenderer={this.showPopUpForFavorableVp2} label="Favorable Supplier 2" dataKey="favorableVendor2Name" width={400} />
  //                                               <Column style={{ whiteSpace: "normal" }} cellRenderer={this.showPopUpForFavorableVp3} label="Favorable Supplier 3" dataKey="favorableVendor3Name" width={400} />
  //                                               <Column style={{ whiteSpace: "normal" }} cellRenderer={this.showPopUpForFavorableVp4} label="Favorable Supplier 4" dataKey="favorableVendor4Name" width={400} />
  //                                               <Column style={{ whiteSpace: "normal" }} cellRenderer={this.showPopUpForFavorableVp5} label="Favorable Supplier 5" dataKey="favorableVendor5Name" width={400} />
  //                                           </Table>
  //                                       )}
  //                                   </AutoSizer>
  //                               )}
  //                           </InfiniteLoader>
  //           </div>
  //   )
  // }

  BusinessGroupUpperCase = (cell, rows) => {
    let tier = _get(rows, 'businessGroupName', "")
    let businessGroupName = tier;
    if (businessGroupName) {
        return <div className="businessGroupName" style={{textTransform: 'capitalize'}}>{businessGroupName}</div>
    }
}
  showPopUpForFavorableVp1 = (cell, row) => {
    //
    if (_isEmpty(row.favorableVendor1Name)) {
        return <div>--</div>
    }
    return <div>{row.favorableVendor1Name} <Link onClick={(e) => this.showModalForFavorableVendor(1, row,row.favorableVendor1Id, row.favorableVendor1Name)}> <i class="fas fa-comment-alt"></i></Link></div>
  }
  showPopUpForFavorableVp2= (cell, row) => {
    if (_isEmpty(row.favorableVendor2Name)) {
        return (<div>--</div>)
    }
    return <div>{row.favorableVendor2Name} <Link onClick={(e) => this.showModalForFavorableVendor(2, row,row.favorableVendor2Id, row.favorableVendor2Name)}><i class="fas fa-comment-alt"></i></Link></div>
  }
  showPopUpForFavorableVp3 = (cell, row) => {
    if (_isEmpty(row.favorableVendor3Name)) {
        return (<div>--</div>)
    }
    return <div>{row.favorableVendor3Name} <Link onClick={(e) => this.showModalForFavorableVendor(3, row,row.favorableVendor3Id, row.favorableVendor3Name)}><i class="fas fa-comment-alt"></i></Link></div>
  }
  showPopUpForFavorableVp4 = (cell, row) => {
    if (_isEmpty(row.favorableVendor4Name)) {
        return (<div>--</div>)
    }
    return <div>{row.favorableVendor4Name} <Link onClick={(e) => this.showModalForFavorableVendor(4, row, row.favorableVendor4Id,row.favorableVendor4Name)}><i class="fas fa-comment-alt"></i></Link></div>
  };
  showPopUpForFavorableVp5 = (cell, row) => {
  if (_isEmpty(row.favorableVendor5Name)) {
      return (<div>--</div>)
  }
  return <div>{row.favorableVendor5Name} <Link onClick={(e) => this.showModalForFavorableVendor(5, row, row.favorableVendor5Id,row.favorableVendor5Name)}><i class="fas fa-comment-alt"></i></Link></div>
  };
  
  showModalForFavorableVendor = (num,row,vendorId,vpSelected) => {
    return(
  this.setState({numberOfFavorableVp:num, selectedCategoryId :row.businessGroupId,
    selectedCategory: row.businessGroupName,
    selectedFavorableVpId:vendorId,selectedFavorableVp:vpSelected,
    productGroupName:row.productGroupName, productGroupId:row.productGroupId,
    showPopUpForFavorableVp: true })
    )
  }

  
  closeFavorableVendorModal = () => {
    this.setState({ showPopUpForFavorableVp: false,disableVendorDropdown:true });
  }
  handleOnChange(event) {
    this.setState({textareaValue: event.target.value})
    this.refs.comment.value = '';
  }
  handleClickVendor = (e, value) => {
    let arr = [];
    let arr1 = [];
    let valuestr = [value.value];
    if (valuestr > 0) {
        let valueee = valuestr.map((option, index) => {
            let val = _find(value.options, ['value', option])
            arr.push(val.value)
            arr1.push(val.text)
        })
  
  
    }
    this.setState({ suggestedFavorableVendorId: encodeURIComponent(arr), suggestedFavorableVendorName: encodeURIComponent(arr1),selectFavorableVpErrorMessage:'' })
  
  }
  sendFeedbackForFavorableVendor(){
  
    let selections = {
        productId: this.state.productGroupId,
        productDesc: this.state.productGroupName,
        favorableVendorId:this.state.selectedFavorableVpId,
        favorableVendorName:this.state.selectedFavorableVp,
        feedbackComment:this.state.textareaValue,
        favorableVendorWrong :this.state.feedbackToggleForFavorableVp,
        suggestedFavorableVendorId:this.state.suggestedFavorableVendorId,
        suggestedFavorableVendorName:this.state.suggestedFavorableVendorName,
        categoryId :this.state.selectedCategoryId,
        categoryName : this.state.selectedCategory,
    }
  
    if (!this.state.suggestedFavorableVendorName) {
        this.setState({ selectFavorableVpErrorMessage: 'Please select a Supplier' }, () => {});
    } else {
      this.setState({ showPopUpForFavorableVp: false,disableVendorDropdown:true,textareaValue :'', suggestedFavorableVendorName :'',selectFavorableVpErrorMessage: '' }, () => {
        this.props.saveProductFeedbackAPI(selections, (res) => {
          toast(res.data.text);
  
      });
  
      });
  }
  }
  renderPaginationShowsTotal(start, to, total) {
    return (
      <p style={ { color: '' } }>
        Showing rows { start } to { to }
      </p>
    );
  }
  renderConversionOpportunity() {
    const options = {
      sizePerPageDropDown: this.renderSizePerPageDropDown
      // sizePerPage: 100,
      // paginationShowsTotal: this.renderPaginationShowsTotal,
             
    }
    return (
      <div className="">
        <div className="card-deck">
          <div className="card shadow-sm mb-3">
            <div className="card-body">
            <h5 style={{textDecorationLine: 'underline',marginBottom:'-20px'}}>Conversion Opportunity</h5>

              <BootstrapTable search options={options} pagination height='350' data={this.props.terminatedVpOppConversionOpp} striped hover multiColumnSearch version="4">
                {console.log('conversion opp 123',this.props.terminatedVpOppConversionOpp)}
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }}  width ="150" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='leavingVendorName'>Leaving Supplier</TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }}  width ="160" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='memberName'>Member Name</TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }}  width ="140" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat = {this.BusinessGroupUpperCase} dataField='businessGroupName'>Business Group</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}   width ="130" dataSort={true} dataField='productGroupName'>Product Group</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  width ="100" dataSort={true} dataField='purchases' dataFormat={PriceFormatter}>Purchases</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}   dataSort={true} hidden dataField='productGroupId'></TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  dataSort={true} hidden dataField='favorableVendor1Id'></TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  dataSort={true} hidden dataField='favorableVendor2Id'></TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  dataSort={true} hidden dataField='favorableVendor3Id'></TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  dataSort={true} hidden dataField='favorableVendor4Id'></TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  dataSort={true} hidden dataField='favorableVendor5Id'></TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  width ="160" dataSort={true}  dataFormat={this.showPopUpForFavorableVp1} dataField='favorableVendor1Name'>Favorable Supplier 1</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  width ="160" dataSort={true}  dataFormat={this.showPopUpForFavorableVp2} dataField='favorableVendor2Name'>Favorable Supplier 2</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  width ="160" dataSort={true}  dataFormat={this.showPopUpForFavorableVp3}  dataField='favorableVendor3Name'>Favorable Supplier 3</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  width ="160" dataSort={true}  dataFormat={this.showPopUpForFavorableVp4} dataField='favorableVendor4Name'>Favorable Supplier 4</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  width ="160" dataSort={true}  dataFormat={this.showPopUpForFavorableVp5} dataField='favorableVendor5Name'>Favorable Supplier 5</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div>
    )
  }
  renderConversionOpportunityPODetails() {
    const { conversionOppPoDetailsData } = this.props;
    const options = {
      sizePerPageDropDown: this.renderSizePerPageDropDown
      // sizePerPage: 100,
      //  paginationShowsTotal: this.renderPaginationShowsTotal,
             
    }
    return (
      <div className="">
        <div className="card-deck">
          <div className="card shadow-sm mb-3">

            {/* <div className="card-header">
              Conversion Opportunity PO Details
                        </div> */}
            <div className="card-body">
            <h5 style={{textDecorationLine: 'underline',marginBottom:'-20px'}}>Conversion Opportunity PO Details</h5>

              <BootstrapTable search options={options} pagination height='350' data={conversionOppPoDetailsData} striped hover version="4">
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width ="100" dataSort={true} isKey dataField='leavingVendorName'>Leaving Supplier</TableHeaderColumn>
                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width ="160" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='memberName'>MEMBER NAME</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width ="100" dataSort={true} dataField='poCount'>PO COUNT</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width ="100" dataFormat={PriceFormatter} dataSort={true} dataField='purchases'>Purchases</TableHeaderColumn>
                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width ="160" dataFormat={PriceFormatter} dataSort={true} dataField='avgPurchases'>Average Purchase/PO</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div>
    )
  }
  handleChangeOfDropdown(event) {
    let params = this.state.params;
    params = paramsToJSON1(params);
            let obj = {};
            obj[event.name] = event.value;
            params.quarter = event.value;
            let quarter = params.quarter
            params = jsonToParam(params);
            this.setState({
                quarter:quarter,
                params: params})
            this.setState(obj, () => {
                this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
            });
    
        }
handleChangeOfDropdownextra(event) {
    let obj = {};
    obj[event.name] = event.value;
    this.setState(obj, () => {

      //params= paramsToJSON(params);
      this.setFilter({ buyingGroupId: this.state.buyingGroupId, terminatedVendorId: this.state.terminatedVendorId });
      //params= jsonToParam(params);
    });
  }
  componentWillReceiveProps(props) {
        const { top10Members, top10ProductGroups } = this.props;
        let jsonArr = [];
        let jsonArrName = [];
        if (!_isEmpty(top10Members)) {
          top10Members.chartData1.map((data, index) => {
            let jsonObj = {};
          jsonObj["Purchases"] = data;
           jsonObj.label = this.props.top10Members.chartData1MemberId[index];
           jsonObj.productGroupName = this.props.top10Members.chartData1Member[index]; 
           jsonArr.push(jsonObj);
          });
        }
        else {
          jsonArr.push([]);
        }
        jsonArr.shift();
        //for top 10 product groups
        let jsonArrPG = [];
        if (!_isEmpty(top10ProductGroups)) {
          top10ProductGroups.chartData2.map((data, index) => {
            let jsonObj = {};
            jsonObj["Purchases"] = data;
            jsonObj.label = this.props.top10ProductGroups.chartData1PGId[index];
            jsonObj.productGroupName = this.props.top10ProductGroups.chartData1PG[index];
            jsonArrPG.push(jsonObj);
          });
        }
        else {
          jsonArrPG.push([]);
        }
        jsonArrPG.shift();

        if (!_isEqual(jsonArr, this.state.dataForChart1.data.columns)) {
    
          this.setState({
            dataForChart1: {
              data: {
                columns: [
                  top10Members.chartData1,
                ],
                json: jsonArr,
                keys: {
                  x: 'label',
                  value: ["Purchases"],
                  // x1: 'data1',
                  // data1: ["memberName"],
                  //y: 'label'
                },
                type: 'bar',
              //   axes: {
              //     x1: 'data1',
              //     data1: ["memberName"],
              // },
              
              tooltip: {
                format: {
                    title: d => this.props.top10Members.chartData1Member[d+1],
                    value: (value, ratio, id) => accounting.formatMoney(value)
                }
            },
                colors: {
                  "Purchases": '#1f77b4'
                },
                //value: ["Member Purchases"],
    
    
              },
              legend: {
                show: true
              },
              bar: {
                width: {
                  ratio: 0.2
                },
              },
    
            }
          });
        }
        if (!_isEqual(jsonArrPG, this.state.dataForChart2.data.columns)) {
    
          this.setState({
            dataForChart2: {
              x: 'x',
              data: {
                columns: [

                  this.props.top10ProductGroups.chartData2,
                  // console.log("chartdataproduct", top10ProductGroups.chartData2)
                ],
                json: jsonArrPG,
                keys: {
                  // x: 'label',
                  value: ["Purchases"],
    
                },
                type: 'bar',
                tooltip: {
                  format: {
                      title: d => this.props.top10ProductGroups.chartData1PG[d+1],
                      value: (value, ratio, id) => accounting.formatMoney(value)
                  }
              },
                colors: {
                  "Purchases": '#1f77b4'
                },
    },

              legend: {
                show: true
              },
              bar: {
                width: {
                  ratio: 0.2
                },
              },
            }
          });
        }
      }

  handleOnChange(event) {
    this.setState({
      textareaValue: event.target.value
    })
    this.refs.comment.value = '';
  }
  handleClickVendorFull = (e, value) => {
    // ;
    let params = this.state.params;
    params = paramsToJSON(params);
    let arr = [];
    let valstr = [value.value];
    if (valstr != "" && valstr != "undefined") {
        let valueee = valstr.map((option, index) => {
            let val = _find(value.options, ['value', option])
            arr.push(val.value)
        })
        params.terminatedVendorId = arr
    }
    else {
      params.terminatedVendorId = "";
    }
    params = jsonToParam(params);
    this.props.getTerminatedVpOppTopTenMembersAPI(params);
    this.props.getTerminatedVpOppVolumeOppByMemberAPI(params);
    this.props.getTerminatedVpOppTopTenProductGroupsAPI(params);
    this.props.getTerminatedVpOppVolumeOppByProductGroupAPI(params);
    this.props.getTerminatedVpOppConversionOppPoDetailsAPI(params);
    this.props.getTerminatedVpOppConversionOppAPI(params);
    this.props.getTerminatedVpOppVendorNamesAPI();

    this.setState({
        params: params,
      })
  
}
handleChangeOfDropdownMonth = (e) => {
 
  let params = this.state.params;
  params = paramsToJSON1(params);
  let month = ''
  params.month = e.value
  month = params.month
  let selectedItem =  {label: monthName1(month), value: month}
  if(month >= 1 && month <= 3){
    params.quarter= 1
}
else if(month >= 4 && month <= 6){
    params.quarter = 2
}
else if(month >= 7 && month <= 9){
    params.quarter = 3
}
else if(month >= 10 && month <= 12){
    params.quarter = 4
}
  params = jsonToParam(params);
  this.setState({
      params: params,
      selectedItem: selectedItem,
      
  })
  this.props.getCorporateConversionMonthsFilterAPI(params);
  this.props.getTerminatedVpOppTopTenMembersAPI(params);
  this.props.getTerminatedVpOppVolumeOppByMemberAPI(params);
  this.props.getTerminatedVpOppTopTenProductGroupsAPI(params);
  this.props.getTerminatedVpOppVolumeOppByProductGroupAPI(params);
  this.props.getTerminatedVpOppConversionOppPoDetailsAPI(params);
  this.props.getTerminatedVpOppConversionOppAPI(params);
  this.props.getTerminatedVpOppVendorNamesAPI();


}
  handleClickbuyingGroupId = (e, value) => {
    //  ;
    let params = this.state.params;
    params = paramsToJSON1(params);
    // ;

    params.buyingGroupId = [e.target.textContent]
    params = jsonToParam(params);
    this.props.getTerminatedVpOppTopTenMembersAPI(params);
    this.props.getTerminatedVpOppVolumeOppByMemberAPI(params);
    this.props.getTerminatedVpOppTopTenProductGroupsAPI(params);
    this.props.getTerminatedVpOppVolumeOppByProductGroupAPI(params);
    this.props.getTerminatedVpOppConversionOppPoDetailsAPI(params);
    this.props.getTerminatedVpOppConversionOppAPI(params);
    this.props.getTerminatedVpOppVendorNamesAPI();
  }

  setFilter = (filter) => {
    console.log(filter);
    let params = this.state.params;
    params = paramsToJSON1(params);
    if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";
            // params.quarter = filter.quarter;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {

            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            // params.month = filter.month;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            // params.year = filter.year;
            // params.month = filter.month;
            params.period = filter.period;
        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }
      else if (filter.buyingGroupId == undefined) {
          params.buyingGroupId = params.buyingGroupId;

      }
    else if (filter.buyingGroupId != undefined || filter.terminatedVendorId == undefined) {
      params.buyingGroupId = filter.buyingGroupId;
      params.terminatedVendorId = params.terminatedVendorId;

  }
  else if (filter.terminatedVendorId != undefined || filter.buyingGroupId == undefined) {
      params.terminatedVendorId = filter.terminatedVendorId;
      params.buyingGroupId = params.buyingGroupId;

  }
    params = jsonToParam(params);
    //
    this.setState({
      params: params,
      refreshData: true,
      isLoading: true
    }, () => Promise.all([
      this.props.getCorporateConversionMonthsFilterAPI(params),
      this.props.getTerminatedVpOppTopTenMembersAPI(params),
      this.props.getTerminatedVpOppVolumeOppByMemberAPI(params),
      this.props.getTerminatedVpOppTopTenProductGroupsAPI(params),
      this.props.getTerminatedVpOppVolumeOppByProductGroupAPI(params),
      this.props.getTerminatedVpOppConversionOppPoDetailsAPI(params),
      this.props.getTerminatedVpOppVendorNamesAPI(),
      this.props.getProductCategorycorporateAPI(params),
      this.props.getTerminatedVPNamesForCorporateAPI(params),
      this.props.getMemberVendorNamesAPI(params),
      this.props.getTerminatedVpOppConversionOppAPI(params),
     
    ]).then(([groupRebateData]) => {
      this.setState({
          isLoading: false,
          ListData: groupRebateData
      })
    }).catch(err => {

      this.setState({
        isLoading: false
      })
    }))

  }

  ProductFeedback = (cell, row) => {
      return (
        <OverlayTrigger overlay={(<Tooltip>Product Feedback for {row.productGroupName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
               
          <Link onClick={(e) => {
            e.preventDefault();
              this.showProductFeedbackModal(row)
          }}> <i className="fas fa-comment-alt"></i></Link>
          </OverlayTrigger>
      )
  }

  showProductFeedbackModal = (row) => {
   // ;
    this.setState({ productId: row.productId, productDesc: row.productDesc,
        showProductFeedbackModal: true,showPopUpForProductFedbackDetails:true });

}
closeProductFeedbackModal = () => {
    this.setState({ showPopUpForProductFedbackDetails:false,showProductFeedbackModal: false ,disableNewProductCategoryDropdown:true});
}

handleOnChange(event) {
    this.setState({
      textareaValue: event.target.value
    })
    this.refs.comment.value = '';
  }
  handleCategoryClick = (e, value) => {
    let arr = [];
    let arr1 = [];
    let valuestr = [value.value];
    if (valuestr > 0) {
        let valueee = valuestr.map((option, index) => {
            let val = _find(value.options, ['value', option])
            arr.push(val.value)
            arr1.push(val.text)
        })
  
  
    }
    this.setState({ suggestedCategoryId: encodeURIComponent(arr), suggestedCategoryName: encodeURIComponent(arr1),selectFavorableVpErrorMessage:'' })
  
  }
sendProductFeedback() {
   //;
  let selections = {
    productId: this.state.productId,
    productDesc: this.state.productDesc,
    categoryId:this.state.productGroupId,
    categoryName:this.state.productGroupName,
    feedbackComment:this.state.textareaValue,
    productCategoryWrong :this.state.feedbackToggleForWrongClassification,
    suggestedCategoryId:this.state.suggestedCategoryId,
    suggestedCategoryName:this.state.suggestedCategoryName,
}

  if (!this.state.suggestedCategoryName) {
    this.setState({ selectCategoryErrorMessage: 'Please select a Category' }, () => {
    });
} else {
  this.setState({ showPopUpForProductFedbackDetails:false,disableNewProductCategoryDropdown:true,textareaValue :'',showProductFeedbackModal: false, selectCategoryErrorMessage: '' }, () => {
    this.props.saveProductFeedbackAPI(selections, (res) => {
      toast(res.data.text);

  });

  });
}
}

  render() {
    const { showQuarter } = this.state;
        const { monthName } = this.props;
    const { dataForChart1, dataForChart2 } = this.state;
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    const options = {
      // sizePerPage: 100,
      // paginationShowsTotal: this.renderPaginationShowsTotal,
      sizePerPageDropDown: this.renderSizePerPageDropDown
             
    }
    let params = this.state.params;
    params = paramsToJSON(params);
    return (
      <div>
         <ToastContainer style={{zIndex: '9999'}}  />
          <nav className="Filters navbar">
          <div style={{ marginLeft: "20px" }}>
            <span className="navbar-brand nav-head">Conversion Opportunity</span></div>
          <div className="filter-wrapper" style={{ marginRight: "60px" }}>
            <ul className="navbar-nav flexRowForFilters" >
              <li className="nav-item">
                <select className="form-control" style ={{ height :'38px' }} data-toggle="dropdown" onChange={(e) => { this.handleChangeOfDropdownextra({ name: "buyingGroupId", value: e.target.value }) }}>
                  <option value="0" title="IMARK &amp; IMARK LLC" selected="">IMARK PLUMBING &amp; IMARK LLC</option>
                  <option value="2">IMARK LLC</option>
                  <option value="1">IMARK PLUMBING</option>
                </select>
                </li>
                <li className="nav-item">
              <Dropdown clearable onChange={(e, value)=>this.handleClickVendorFull(e, value)} placeholder='Select Leaving Supplier' search fluid selection options={this.props.vendorNamesListFull} />

              </li>
               <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li>
                            <li className="nav-item">
                            <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                        value={this.state.selectedYear}
                                        options={this.state.yearval} />
                            </li>
                            {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control" style ={{height:'38px',width:'80px'}} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                        <option value="1" selected={ params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={ params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={ params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={ params.quarter == 4 ? true : false} >QTR4</option>
                                    </select>

                                </li>
                                :
                                <li className = "nav-item">
                                    <Select
                                        onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                        autosize={true}
                                        value={this.state.selectedItem}
                                        options={this.state.items} />

                                </li>
                            }
                        

                    </ul>

           
              <ExcelFile element={<button className="btn btn-primary" style={{ marginBottom: "7px", height:'38px',marginLeft:'4px'}} >Export</button>}>
                <ExcelSheet data={this.props.TerminatedVpOppVolumeOppByMember} name="Volume Opportunity By Member">
                  <ExcelColumn label="MEMBER NAME" value="memberName" />
                  <ExcelColumn label="MEMBER PURCHASES" value="purchases" />
                  <ExcelColumn label="LEAVING SUPPLIER" value="leavingVendorName" />
                </ExcelSheet>
                <ExcelSheet data={this.props.terminatedVpOppVolumeOppByProductGroup} name="Volume Opportunity By Product Group">
                  <ExcelColumn label="PRODUCT GROUP" value="productGroupName" />
                  <ExcelColumn label="PURCHASES" value="purchases" />
                  <ExcelColumn label="LEAVING SUPPLIER" value="leavingVendorName" />
                </ExcelSheet>
                <ExcelSheet data={this.props.terminatedVpOppConversionOpp} name=" VP Conversion Opportunity">
                  <ExcelColumn label="LEAVING SUPPLIER" value="leavingVendorName" />
                  <ExcelColumn label="MEMBER NAME" value="memberName" />
                  <ExcelColumn label="BUSINESS GROUP" value="businessGroupName" />
                  <ExcelColumn label="PRODUCT GROUP" value="productGroupName" />
                  <ExcelColumn label="PURCHASES" value="purchases" />
                  <ExcelColumn label="FAVOURABLE SUPPLIER 1" value="favorableVendor1Name" />
                  <ExcelColumn label="FAVOURABLE SUPPLIER 2" value="favorableVendor2Name" />
                  <ExcelColumn label="FAVOURABLE SUPPLIER 3" value="favorableVendor2Name" />
                  <ExcelColumn label="FAVOURABLE SUPPLIER 4" value="favorableVendor4Name" />
                  <ExcelColumn label="FAVOURABLE SUPPLIER 5" value="favorableVendor5Name" />
                </ExcelSheet>
                <ExcelSheet data={this.props.TerminatedVpOppConversionOppPoDetails} name="Conversion Opportunity PO Details">
                  <ExcelColumn label="LEAVING SUPPLIER" value="leavingVendorName" />
                  <ExcelColumn label="MEMBER NAME" value="memberName" />
                  <ExcelColumn label="PO COUNT" value="poCount" />
                  <ExcelColumn label="PURCHASES" value="purchases" />
                  <ExcelColumn label="AVERAGE VOLUME/PO" value="avgPurchases" />
                </ExcelSheet>
              </ExcelFile>
            
          </div>
        </nav>
      
         {this.state.isLoading ? matLoader() : ''}

        {/* first row */}
        <div className="container-fluid" style={{ marginLeft: "60px", marginRight: "60px", maxWidth: "91%" }}>
          <div className="row">
            <div className="col-6">
              <div className="card-deck" style={{ height: "500px"}}>
                <div className="card shadow-sm mb-3">
                  <div className="card-header">Top 10 Members</div>
                  <div className="card-body">
                    <div className="chart c3" id="topMemberChart">
                      {/* //e = {dataForChart1.data.data1}  */}
                      <C3Chart data={dataForChart1.data} tooltip= {dataForChart1.tooltip} axis={dataForChart1.axis} />
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="col-6">
              {this.renderOpportunityByMember()}
            </div>

          </div>

          {/* second row */}
          <div className="row">
            <div className="col-6">
              {this.renderOpportunityByProductGroup()}
            </div>
            <div className="col-6" >
              <div className="card shadow-sm mb-3" style={{ height: "450px"}}>
                <div className="card-header">
                  Top 10 Product Groups
                        </div>
                <div className="card-body">
                  <div class="chart c3" id="topProductChart">
                    <C3Chart data={dataForChart2.data} axis={dataForChart2.axis} tooltip={dataForChart2.tooltip}/>
                  </div>
                </div>

              </div>
            </div>
          </div>
          {/* third row */}
          <div className="row">

            <div className="col-12">
              {this.renderConversionOpportunityPODetails()}
            </div>
          </div>
          {/* fourth row */}
          <div className="row">

            <div className="col-12"  style={{ width: "700px",paddingBottom:"10px" }} >
              {this.renderConversionOpportunity()}
            </div>
            {this.state.showProductInfo ?
            
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                <div className="modal-content" style={{ width: "700px" }}>

                                    <div className="modal-header">
                                        <h5 className="modal-title" > Products Details for {this.state.productGroupName}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductInfo() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" >
                                
                            <BootstrapTable search options={options} pagination height='300' data={this.props.getProductDetail} hover version="4">
                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey hidden dataField='productGroupId'></TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true}  dataField='productDesc'>Products</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="80" dataFormat={this.ProductFeedback} dataField='productGroupId' >Product</TableHeaderColumn>
                           </BootstrapTable>
                            <div >
                                        
                                            <span className="errorText">{}</span>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" onClick={(e) => { this.closeProductInfo() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }
                        
                        {this.state.showPopUpForProductFedbackDetails ?
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                            <div className="modal-content" style={{ width: "700px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Product Feedback for {this.state.productDesc} </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductFeedbackModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <div >
                                        <form>
                                        <div className="form-group feedbackToggle">
                                                      <label >Is {this.state.productDesc} wrongly classified as {this.state.productGroupName}? </label>
                                                      <Checkbox toggle onChange={(e, value) => {
                                                          if (value.checked) {
                                                              this.setState({ disableNewProductCategoryDropdown: false, selectCategoryErrorMessage: '' });
                                                          } else {
                                                              this.setState({ disableNewProductCategoryDropdown: true, selectCategoryErrorMessage: '' });
                                                          }
                                                          this.setState({ feedbackToggleForWrongClassification: value.checked });
                                                      }} />
                                                  </div>
                                                  <div className="form-group feedbackToggle">
                                                      <Dropdown
                                                          placeholder='Select new Product Category'
                                                          disabled={this.state.disableNewProductCategoryDropdown}
                                                          fluid
                                                          search
                                                          selection
                                                          value={this.props.value}
                                                          options={this.props.ProductCategoryList}
                                                          onChange={(e, value) => this.handleCategoryClick(e, value)}
                                                      />
                                                  </div>
                                            <div className="form-group feedbackToggle">
                                                    <label>Comments</label>
                                                    <textarea ref="comment" rows={2} cols={20} value={this.state.textareaValue} 
                                                    onChange={(e,value) => this.handleOnChange(e,value)}/>
                                                   
                                                </div>

                                        </form>
                                        <span className="errorText">{this.state.selectCategoryErrorMessage}</span>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                <button type="button" onClick={(e) => { this.sendProductFeedback() }} className="btn btn-primary">Submit</button> 
                                <button type="button" onClick={(e) => { this.closeProductFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>  : ''
                    }
 
                 {this.state.showPopUpForFavorableVp ?
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                            <div className="modal-content" style={{ width: "700px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Favorable Supplier Feedback for {this.state.selectedFavorableVp} </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeFavorableVendorModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <div >
                                        <form>
                                            <div className="form-group feedbackToggle">
                                                <label >Is {this.state.selectedFavorableVp}  wrong as Favorable Supplier for <b>{this.state.selectedCategory}</b>? </label>
                                                <Checkbox toggle onChange={(e, value) => {
                                                     if (value.checked) {
                                                        this.setState({ disableVendorDropdown: false });
                                                    } else {
                                                        this.setState({ disableVendorDropdown: true });
                                                    }
                                                    this.setState({ feedbackToggleForFavorableVp: value.checked });
                                                }} />
                                            </div>
                                            <div className="form-group feedbackToggle">
                                                <Dropdown
                                                    placeholder='Select Favorable Supplier '
                                                    disabled={this.state.disableVendorDropdown}
                                                    fluid
                                                    search
                                                    selection
                                                    value={this.props.value}
                                                    options={this.props.vendorNamesList}
                                                    onChange={(e, value) => this.handleClickVendor(e, value)}
                                                />
                                            </div>
                                            <div className="form-group feedbackToggle">
                                                    <label>Comments</label>
                                                    <textarea ref="comment" rows={5} cols={30} value={this.state.textareaValue} 
                                                    onChange={(e,value) => this.handleOnChange(e,value)}/>
                                                  
                                                </div>

                                        </form>
                                        <span className="errorText">{this.state.selectFavorableVpErrorMessage}</span>
                                    </div>
                                </div>

                                <div className="modal-footer">

                                    <button type="button" onClick={(e) => { this.sendFeedbackForFavorableVendor() }} className="btn btn-primary">Submit</button>
                                    <button type="button" onClick={(e) => { this.closeFavorableVendorModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div> : ''}

                </div>
          </div>
        </div>
      // </div>
    )
  }
}
function mapStateToProps(state) {
  //for top 10 members
  let chartData = _get(state, 'corporate.terminatedVpOppTopTenMembers', []);
  var excludeAfterIndex = 10;
  let chartData1Arr = [];
  let chartData1ArrMemberId = [];
  let chartData1ArrMemberId1 = [];
  if (!_isEmpty(chartData)) {
    chartData.map((data, index) => {
      // if (index < excludeAfterIndex) {

        chartData1Arr.push(_get(data, 'purchases', ''));
        chartData1ArrMemberId.push(_get(data, 'memberName', ''));
        chartData1ArrMemberId1.push(_get(data, 'memberId', ''));
      // }
    })
  }
  else {
    chartData1Arr.push([]);
    chartData1ArrMemberId.push([]);
    chartData1ArrMemberId1.push([]);
  }
  chartData1Arr.unshift("data1");
  chartData1ArrMemberId.unshift("data2");
  chartData1ArrMemberId1.unshift("data3");

  //console.log(chartData1Arr);
  //for top 10 product groups
  let chartDataProductGroup = _get(state, 'corporate.terminatedVpOppTopTenProductGroups', []);

  var excludeAfterIndex = 10;

  let chartDataProductGroupArr = [];
  let chartDataProductGroupNames = [];
  let chartDataProductGroupId = [];
  if (!_isEmpty(chartDataProductGroup)) {
    chartDataProductGroup.map((data, index) => {
      // if (index < excludeAfterIndex) {
      //;
      chartDataProductGroupArr.push(_get(data, 'purchases', ''));
      chartDataProductGroupNames.push(_get(data, 'productGroupName', ''));
      chartDataProductGroupId.push(_get(data, 'productGroupId', ''));
      // }
    })
  }
  else {
    chartDataProductGroupArr.push([]);
    chartDataProductGroupNames.push([]);
    chartDataProductGroupId.push([]);
  }
  chartDataProductGroupArr.unshift("data1");
  chartDataProductGroupNames.unshift("data2");
  chartDataProductGroupId.unshift("data3");
  //;
  // chartDataProductGroupArr.reverse();
  // chartDataProductGroupNames.reverse();
  //console.log(chartDataProductGroupNames);

  //for tvpo dropdown
  let vendorNames = [];

  let vendorNameprops = _get(state, 'corporate.getTerminatedVPNamesForCorporate', []);
  //  ;
  vendorNameprops && vendorNameprops.map((vname, index) => {
    let vendorNameObj = {
        key: index,
        text: vname.vendorName,
        value: vname.vendorId
    }
    vendorNames.push(vendorNameObj)
})

 let ProductCategory = [];
 // ;
 let ProductCategoryprops = _get(state, 'corporate.getProductCategorycorporate', []);
 ProductCategoryprops && ProductCategoryprops.map((vname, index) => {
     //;
     let ProductCategoryObj = {
         key: index,
         text: vname.productCategory,
         value: vname.productCategoryId,
     }
     ProductCategory.push(ProductCategoryObj)
     // ;
 })
 let vendorNames1 = [];
 let vendorNameprops1 = _get(state, 'corporate.getConversionOppVendorList', []);
 vendorNameprops1 && vendorNameprops1.map((vname, index) => {
     let vendorNameObj1 = {
         key: index,
         text: vname.vendorName,
         value: vname.vendorId
     }
     vendorNames1.push(vendorNameObj1)
 })
  return {
    ProductCategoryList:ProductCategory,
    top10Members: {
      chartData1: chartData1Arr,
      chartData1Member: chartData1ArrMemberId,
      chartData1MemberId: chartData1ArrMemberId1,
    },
    top10ProductGroups: {
      chartData2: chartDataProductGroupArr,
      chartData1PG: chartDataProductGroupNames,
      chartData1PGId: chartDataProductGroupId
    },
    volumeOpportunityByMember: _get(state, 'corporate.volumeOpportunityByMember', []),
    terminatedVpOppVolumeOppByProductGroup: _get(state, 'corporate.terminatedVpOppVolumeOppByProductGroup', []),
    conversionOppPoDetailsData: _get(state, 'corporate.conversionOppPoDetailsData', []),
    terminatedVpOppConversionOpp: _get(state, 'corporate.terminatedVpOppConversionOpp', []),
    getProductDetail:_get(state, 'corporate.getProductDetail',[]),
    vendorNamesList: vendorNames,
    vendorNamesListFull: vendorNames1,
    getCorporateConversionMonthsFilter:_get(state, 'corporate.getCorporateConversionMonthsFilter',[]),
     tabTracking: _get(state, 'corporate.tabTracking', []),

  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getTerminatedVpOppVolumeOppByMemberAPI: getTerminatedVpOppVolumeOppByMember,
    getTerminatedVpOppConversionOppPoDetailsAPI: getTerminatedVpOppConversionOppPoDetails,
    getTerminatedVpOppConversionOppAPI: getTerminatedVpOppConversionOpp,
    getTerminatedVpOppTopTenMembersAPI: getTerminatedVpOppTopTenMembers,
    getTerminatedVpOppVolumeOppByProductGroupAPI: getTerminatedVpOppVolumeOppByProductGroup,
    getTerminatedVpOppTopTenProductGroupsAPI: getTerminatedVpOppTopTenProductGroups,
    getTerminatedVpOppVendorNamesAPI: getTerminatedVpOppVendorNames,
    getProductDetailAPI:getProductDetail,
    saveProductFeedbackAPI: saveProductFeedback,
    getProductCategorycorporateAPI:getProductCategorycorporate,
    getTerminatedVPNamesForCorporateAPI:getTerminatedVPNamesForCorporate,
    getMemberVendorNamesAPI:getConversionOppVendorList,
    getCorporateConversionMonthsFilterAPI :getCorporateConversionMonthsFilter,
    tabTrackingAPI:tabTracking,
  }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(TerminatedVPOpportunity);